<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle p-1">

    <section class="p-3">
      <div class="flex justify-items-start">
        <h4 class="py-2 text-white text-sm font-bold uppercase mb-3">Delete tour</h4>
      </div>
      <div class="content py-4 text-white">
        <h6>Are you sure, that you want to delete this tour?</h6>
        <p>The tour data will be irreversibly removed.</p>
        <p>Consider instead to make it invisible, by opening it and clicking on “change visibility”.</p>
      </div>

      <div class="flex justify-between pt-2">
        <button type="button" @click.prevent="hideModalFn" class="btn btn-black">X Cancel</button>
        <button v-if="!form.processing" class="btn btn-gradient" @click="deleteTour">
            <i class="trash mr-1 relative top-0.5"></i>Delete
        </button>
        <button v-else class="btn btn-gradient"><Spinner/></button>
      </div>
    </section>

    </div>
  </div>
</div>
</template>

<script>
import Spinner from '@/UI/Spinner';

export default {
  components:{
    Spinner,
  },
  props: ['showModal', 'hideModalFn', 'form'],
  methods:{
    deleteTour(){
      this.form.delete(route('tour.delete', this.form.tour_identifier), {
          preserveScroll: true,
        onSuccess: () => {
          this.hideModalFn();
        },
        onError: (err) => {
          console.log(err);
          this.hideModalFn();
        }
      });
    }
  }
}

</script>
